/* 195c69d710378c75ba1227dcc22655a3ffca27ed
 * This file is automatically generated by graphql-let. */

import * as Types from '../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitializeKinesisMetaQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InitializeKinesisMetaQuery = { __typename?: 'Query', memberClassCode: string, viewer: { __typename?: 'Viewer', hashedMemberNo: string, nolMemberProxyId?: string | undefined } };


export const InitializeKinesisMetaDocument = gql`
    query InitializeKinesisMeta {
  memberClassCode
  viewer {
    hashedMemberNo
    nolMemberProxyId
  }
}
    `;

/**
 * __useInitializeKinesisMetaQuery__
 *
 * To run a query within a React component, call `useInitializeKinesisMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitializeKinesisMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitializeKinesisMetaQuery({
 *   variables: {
 *   },
 * });
 */
export function useInitializeKinesisMetaQuery(baseOptions?: Apollo.QueryHookOptions<InitializeKinesisMetaQuery, InitializeKinesisMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitializeKinesisMetaQuery, InitializeKinesisMetaQueryVariables>(InitializeKinesisMetaDocument, options);
      }
export function useInitializeKinesisMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitializeKinesisMetaQuery, InitializeKinesisMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitializeKinesisMetaQuery, InitializeKinesisMetaQueryVariables>(InitializeKinesisMetaDocument, options);
        }
export type InitializeKinesisMetaQueryHookResult = ReturnType<typeof useInitializeKinesisMetaQuery>;
export type InitializeKinesisMetaLazyQueryHookResult = ReturnType<typeof useInitializeKinesisMetaLazyQuery>;
export type InitializeKinesisMetaQueryResult = Apollo.QueryResult<InitializeKinesisMetaQuery, InitializeKinesisMetaQueryVariables>;